import { render } from "./BackupCodes2FA.vue?vue&type=template&id=3aa8e974&scoped=true"
import script from "./BackupCodes2FA.vue?vue&type=script&lang=js"
export * from "./BackupCodes2FA.vue?vue&type=script&lang=js"

import "./BackupCodes2FA.vue?vue&type=style&index=0&id=3aa8e974&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa8e974"]])

export default __exports__